const features = [
  {
    icon: "ri-bookmark-3-line",
    title: "收藏",
    desc: "把整条话题一次存进我的收藏，形成一个可随时回看的内容清单。",
  },
  {
    icon: "ri-save-3-line",
    title: "保存",
    desc: "保存当前浏览进度与状态，下次打开直接接着看，不用重新找。",
  },
  {
    icon: "ri-bookmark-2-line",
    title: "书签",
    desc: "给重点内容加一个便于检索的定位，需要时快速跳回关键位置。",
  },
  {
    icon: "ri-history-line",
    title: "记录",
    desc: "自动记录浏览轨迹，回头查看自己对哪些话题关注得最多。",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "标记",
    desc: "给话题打上自己的状态标签，例如「已看完」「待追」，管理更清晰。",
  },
  {
    icon: "ri-eye-line",
    title: "关注",
    desc: "对感兴趣的话题持续关注，有新的动态时优先在你的列表中出现。",
  },
];

export default function FeatureShowcase() {
  return (
    <section id="feature" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-5">
            <div className="relative w-full h-[320px] md:h-[440px] rounded-lg overflow-hidden border border-background-300">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cream%20editorial%20flat%20lay%20with%20abstract%20coral%20red%20bookmark%20shapes%20amber%20gold%20accents%20and%20soft%20paper%20texture%2C%20minimal%20magazine%20aesthetic%2C%20clean%20negative%20space&width=1000&height=1000&seq=kanliao-feature-01&orientation=squarish"
                alt="5看料网收藏与书签功能示意"
                title="5看料网 - 收藏、保存、书签、记录、标记、关注"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute left-5 bottom-5 px-4 py-3 rounded-lg bg-background-50 border border-background-200">
                <div className="flex items-center gap-2 text-sm font-medium text-foreground-950">
                  <i className="ri-bookmark-fill text-accent-500"></i>
                  已收藏 1,284 条话题
                </div>
                <div className="mt-1 text-xs text-foreground-500">保存在你的本地设备</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
              <span className="w-6 h-px bg-primary-500"></span>
              Toolkit
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              一套完整的收藏工具箱，好料留在自己手里
            </h2>
            <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">
              5看料网把浏览与留存打通：看到感兴趣的爆料与吃瓜动态，可以立刻收藏、保存、加书签、
              做标记并持续关注，之后再回来一目了然。
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {features.map((f) => (
                <div
                  key={f.title}
                  className="flex gap-3.5 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
                >
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${f.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">
                      {f.title}
                    </h3>
                    <p className="mt-1 text-xs md:text-sm leading-6 text-foreground-600">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}